var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEndIcon = function SvgEndIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 31,
    height: 12,
    fill: "#1A5177"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.984 9.384C11.376 9.248 12.28 8.736 12.672 8.032C13.056 8.736 13.968 9.248 15.352 9.384L15.72 8.552C14.344 8.44 13.624 7.96 13.44 7.464H15.4V6.624H9.952V7.464H11.904C11.72 7.96 11 8.44 9.624 8.552L9.984 9.384ZM12.656 12.904C11.664 12.904 11.168 12.752 11.168 12.392C11.168 12.04 11.664 11.88 12.656 11.88C13.648 11.88 14.144 12.04 14.144 12.392C14.144 12.752 13.648 12.904 12.656 12.904ZM12.656 11.088C11.056 11.088 10.104 11.56 10.104 12.392C10.104 13.224 11.056 13.688 12.656 13.688C14.256 13.688 15.216 13.224 15.216 12.392C15.216 11.56 14.256 11.088 12.656 11.088ZM13.192 9.848V8.968H12.136V9.848H9.344V10.688H16V9.848H13.192ZM19.4314 10.888H20.7194V12.016H19.4314V10.888ZM21.7594 12.016V10.888H22.7914V10.048H18.5194V9.24H22.6234V6.792H17.4634V7.632H21.5834V8.416H17.4714V10.888H18.3914V12.016H16.6954V12.88H23.3754V12.016H21.7594Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEndIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EndIcon.d93c261e.svg";
export { ForwardRef as ReactComponent };